import { BigNumber } from "@ethersproject/bignumber";
import { getAssetDecimals } from "../utils/asset";
import { SUBGRAPH_URI, getSubgraphqlURI, isDevelopment, isProduction, isTreasury, getSolanaAddresses, SOLANA_SUBGRAPH, getSubgraphqlRearnURI, isVIP, } from "../utils/env";
import { PublicKey } from "@solana/web3.js";
import v1deployment from "./v1Deployments.json";
import v2deployment from "./v2Deployments.json";
import governanceDeployment from "./governanceDeployment.json";
import addresses from "./externalAddresses.json";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
export var Chains;
(function (Chains) {
    Chains[Chains["NotSelected"] = 0] = "NotSelected";
    Chains[Chains["Ethereum"] = 1] = "Ethereum";
    Chains[Chains["Avalanche"] = 2] = "Avalanche";
    Chains[Chains["Binance"] = 3] = "Binance";
    Chains[Chains["Solana"] = 4] = "Solana";
})(Chains || (Chains = {}));
export var CHAINID;
(function (CHAINID) {
    CHAINID[CHAINID["NOT_SELECTED"] = -1] = "NOT_SELECTED";
    CHAINID[CHAINID["ETH_MAINNET"] = 1] = "ETH_MAINNET";
    CHAINID[CHAINID["ETH_KOVAN"] = 42] = "ETH_KOVAN";
    CHAINID[CHAINID["AVAX_FUJI"] = 43113] = "AVAX_FUJI";
    CHAINID[CHAINID["AVAX_MAINNET"] = 43114] = "AVAX_MAINNET";
    CHAINID[CHAINID["BINANCE_MAINNET"] = 56] = "BINANCE_MAINNET";
})(CHAINID || (CHAINID = {}));
export var ChainsToCHAINID = (_a = {},
    _a[Chains.NotSelected] = CHAINID.NOT_SELECTED,
    _a[Chains.Ethereum] = CHAINID.ETH_MAINNET,
    _a[Chains.Avalanche] = CHAINID.AVAX_MAINNET,
    _a[Chains.Binance] = CHAINID.BINANCE_MAINNET,
    _a);
export var AllChains = Object.values(CHAINID).filter(function (v) { return !Number.isNaN(Number(v)); });
export var NETWORKS = (_b = {},
    _b[CHAINID.ETH_MAINNET] = "mainnet",
    _b[CHAINID.ETH_KOVAN] = "kovan",
    _b[CHAINID.AVAX_FUJI] = "fuji",
    _b[CHAINID.AVAX_MAINNET] = "avax",
    _b[CHAINID.BINANCE_MAINNET] = "bsc",
    _b);
export var CHAINID_TO_NATIVE_TOKENS = (_c = {},
    _c[CHAINID.NOT_SELECTED] = "WETH",
    _c[CHAINID.ETH_MAINNET] = "WETH",
    _c[CHAINID.ETH_KOVAN] = "WETH",
    _c[CHAINID.AVAX_MAINNET] = "WAVAX",
    _c[CHAINID.AVAX_FUJI] = "WAVAX",
    _c[CHAINID.BINANCE_MAINNET] = "WBNB",
    _c);
export var READABLE_NETWORK_NAMES = (_d = {},
    _d[CHAINID.NOT_SELECTED] = "No Chain Selected",
    _d[CHAINID.ETH_MAINNET] = "Ethereum",
    _d[CHAINID.ETH_KOVAN] = "Kovan",
    _d[CHAINID.AVAX_MAINNET] = "Avalanche",
    _d[CHAINID.AVAX_FUJI] = "Fuji",
    _d[CHAINID.BINANCE_MAINNET] = "Binance",
    _d);
export var isEthNetwork = function (chainId) {
    return chainId === CHAINID.ETH_MAINNET || chainId === CHAINID.ETH_KOVAN;
};
export var isAvaxNetwork = function (chainId) {
    return chainId === CHAINID.AVAX_MAINNET || chainId === CHAINID.AVAX_FUJI;
};
export var isBinanceNetwork = function (chainId) {
    return chainId === CHAINID.BINANCE_MAINNET;
};
export var isEthVault = function (vault) {
    return isEthNetwork(VaultAddressMap[vault].chainId);
};
export var isAvaxVault = function (vault) {
    return isAvaxNetwork(VaultAddressMap[vault].chainId);
};
export var isBinanceVault = function (vault) {
    return isBinanceNetwork(VaultAddressMap[vault].chainId);
};
export var getVaultChain = function (vault) {
    if (isEthVault(vault))
        return Chains.Ethereum;
    else if (isAvaxVault(vault))
        return Chains.Avalanche;
    else if (isBinanceVault(vault))
        return Chains.Binance;
    else if (isSolanaVault(vault))
        return Chains.Solana;
    else
        throw new Error("Unknown network for ".concat(vault));
};
export var getVaultNetwork = function (vault) {
    if (isEthVault(vault))
        return "mainnet";
    else if (isAvaxVault(vault))
        return "avax";
    else if (isBinanceVault(vault))
        return "bsc";
    else
        throw new Error("Unknown network for ".concat(vault));
};
export var NATIVE_TOKENS = ["WETH", "WAVAX", "WBNB", "SOL"];
export var NO_APPROVE_TOKENS = ["WETH", "WAVAX", "WBNB", "SOL"];
export var isNoApproveToken = function (token) {
    return NO_APPROVE_TOKENS.includes(token);
};
export var VaultVersionList = ["earn", "v2", "v1"];
export var EVMVaultList = [
    "rEARN-stETH",
    "rEARN",
    "rsAVAX-THETA",
    "rETH-THETA",
    "ryvUSDC-ETH-P-THETA",
    "rstETH-THETA",
    "rrETH-THETA",
    "rBTC-THETA",
    "rAVAX-THETA",
    "rAAVE-THETA",
    "rBNB-THETA",
    "rUSDC-AVAX-P-THETA",
    "rUNI-THETA",
    "rAPE-THETA",
    "rUSDC-ETH-P-THETA",
];
export var SolanaVaultList = ["rSOL-THETA"];
export var RetailVaultList = __spreadArray(__spreadArray([], EVMVaultList, true), SolanaVaultList, true);
export var TreasuryVaultList = [
    "rPERP-TSRY",
    "rBAL-TSRY",
    "rBADGER-TSRY",
    "rSPELL-TSRY",
    "rSAMB-TSRY",
    "rVIP-wBTC",
    "rVIP-USDC",
    "rVIP-VOL",
    "rVIP-VOL-TWO",
];
var AllVaultOptions = __spreadArray(__spreadArray(__spreadArray([], EVMVaultList, true), TreasuryVaultList, true), SolanaVaultList, true);
var ProdExcludeVault = [];
export var EarnVaultList = ["rEARN", "rEARN-stETH"];
export var VIPVaultList = [
    "rVIP-wBTC",
    "rVIP-USDC",
    "rVIP-VOL",
    "rVIP-VOL-TWO",
];
var AllEarnVaults = __spreadArray(__spreadArray([], EarnVaultList, true), VIPVaultList, true);
var PutThetaVault = [
    "rUSDC-ETH-P-THETA",
    "ryvUSDC-ETH-P-THETA",
    "rUSDC-AVAX-P-THETA",
];
export var SolanaAssets = ["SOL"];
export var isSolanaVault = function (vaultOption) {
    var list = SolanaVaultList;
    return list.includes(vaultOption);
};
export var isSolanaAsset = function (asset) { return SolanaAssets.includes(asset); };
export var StakingVaultList = EVMVaultList;
// @ts-ignore
export var VaultList = isTreasury()
    ? TreasuryVaultList
    : isVIP()
        ? VIPVaultList
        : !isProduction()
            ? RetailVaultList
            : RetailVaultList.filter(function (vault) { return !ProdExcludeVault.includes(vault); });
export var GAS_LIMITS = {
    "rETH-THETA": {
        v1: {
            deposit: 80000,
            withdraw: 100000,
        },
        v2: {
            deposit: 120000,
            withdrawInstantly: 120000,
            completeWithdraw: 300000,
        },
    },
    "rBTC-THETA": {
        v1: {
            deposit: 100000,
            withdraw: 140000,
        },
        v2: {
            deposit: 140000,
            withdrawInstantly: 120000,
            completeWithdraw: 300000,
        },
    },
    "rUSDC-ETH-P-THETA": {
        v1: {
            deposit: 120000,
            withdraw: 120000,
        },
        v2: {
            deposit: 140000,
            withdrawInstantly: 120000,
            completeWithdraw: 300000,
        },
    },
    "ryvUSDC-ETH-P-THETA": {
        v1: {
            deposit: 210000,
            withdraw: 210000,
        },
        v2: {
            deposit: 140000,
            withdrawInstantly: 120000,
            completeWithdraw: 300000,
        },
    },
    "rstETH-THETA": {
        v2: {
            deposit: 170000,
            withdrawInstantly: 130000,
            completeWithdraw: 400000,
        },
    },
    "rrETH-THETA": {
        v2: {
            deposit: 380000,
            withdrawInstantly: 130000,
            completeWithdraw: 300000,
        },
    },
    "rAAVE-THETA": {
        v2: {
            deposit: 380000,
            withdrawInstantly: 130000,
            completeWithdraw: 300000,
        },
    },
    "rUNI-THETA": {
        v2: {
            deposit: 380000,
            withdrawInstantly: 130000,
            completeWithdraw: 300000,
        },
    },
    "rAVAX-THETA": {
        v2: {
            deposit: 380000,
            withdrawInstantly: 130000,
            completeWithdraw: 300000,
        },
    },
    "rsAVAX-THETA": {
        v2: {
            deposit: 380000,
            withdrawInstantly: 130000,
            completeWithdraw: 300000,
        },
    },
    "rBNB-THETA": {
        v2: {
            deposit: 380000,
            withdrawInstantly: 130000,
            completeWithdraw: 300000,
        },
    },
    "rUSDC-AVAX-P-THETA": {
        v2: {
            deposit: 140000,
            withdrawInstantly: 120000,
            completeWithdraw: 300000,
        },
    },
    "rPERP-TSRY": {
        v2: {
            deposit: 380000,
            withdrawInstantly: 130000,
            completeWithdraw: 300000,
        },
    },
    "rBAL-TSRY": {
        v2: {
            deposit: 380000,
            withdrawInstantly: 130000,
            completeWithdraw: 300000,
        },
    },
    "rBADGER-TSRY": {
        v2: {
            deposit: 380000,
            withdrawInstantly: 130000,
            completeWithdraw: 300000,
        },
    },
    "rSPELL-TSRY": {
        v2: {
            deposit: 380000,
            withdrawInstantly: 130000,
            completeWithdraw: 300000,
        },
    },
    "rSAMB-TSRY": {
        v2: {
            deposit: 380000,
            withdrawInstantly: 130000,
            completeWithdraw: 300000,
        },
    },
    "rVIP-wBTC": {
        earn: {
            deposit: 380000,
            withdrawInstantly: 130000,
            completeWithdraw: 300000,
        },
    },
    "rVIP-USDC": {
        earn: {
            deposit: 380000,
            withdrawInstantly: 130000,
            completeWithdraw: 300000,
        },
    },
    "rVIP-VOL": {
        earn: {
            deposit: 380000,
            withdrawInstantly: 130000,
            completeWithdraw: 300000,
        },
    },
    "rVIP-VOL-TWO": {
        earn: {
            deposit: 380000,
            withdrawInstantly: 130000,
            completeWithdraw: 300000,
        },
    },
    "rSOL-THETA": {
        v2: {
            deposit: 380000,
            withdrawInstantly: 130000,
            completeWithdraw: 300000,
        },
    },
    "rAPE-THETA": {
        v2: {
            deposit: 380000,
            withdrawInstantly: 130000,
            completeWithdraw: 300000,
        },
    },
    rEARN: {
        earn: {
            deposit: 380000,
            withdrawInstantly: 130000,
            completeWithdraw: 300000,
        },
    },
    "rEARN-stETH": {
        earn: {
            deposit: 380000,
            withdrawInstantly: 130000,
            completeWithdraw: 300000,
        },
    },
};
/**
 * lm: Liquidity Mining round during July 2021
 * lg5: Liquidity Gauge V4 from curve.fi
 */
export var LiquidityMiningVersionList = ["lg5", "lm"];
var ProdExcludeLiquidityMiningVersion = [];
// @ts-ignore
export var OngoingLMVersion = !isProduction()
    ? LiquidityMiningVersionList
    : LiquidityMiningVersionList.filter(function (lm) { return !ProdExcludeLiquidityMiningVersion.includes(lm); });
export var VaultLiquidityMiningMap = isDevelopment()
    ? {
        lm: {
            "rUSDC-ETH-P-THETA": v1deployment.kovan.RibbonETHPutStakingReward,
            "rBTC-THETA": v1deployment.kovan.RibbonWBTCCoveredCallStakingReward,
            "rETH-THETA": v1deployment.kovan.RibbonETHCoveredCallStakingReward,
        },
        lg5: {
            "rUSDC-ETH-P-THETA": v2deployment.kovan.RibbonETHPutLiquidityGauge,
            "rETH-THETA": v2deployment.kovan.RibbonETHCoveredCallLiquidityGauge,
            "rBTC-THETA": v2deployment.kovan.RibbonWBTCCoveredCallLiquidityGauge,
        },
    }
    : {
        lm: {
            "rUSDC-ETH-P-THETA": v1deployment.mainnet.RibbonETHPutStakingReward,
            "rBTC-THETA": v1deployment.mainnet.RibbonWBTCCoveredCallStakingReward,
            "rETH-THETA": v1deployment.mainnet.RibbonETHCoveredCallStakingReward,
        },
        lg5: {
            "rEARN-stETH": v2deployment.mainnet.RibbonSTETHREarnLiquidityGauge,
            rEARN: v2deployment.mainnet.RibbonREarnLiquidityGauge,
            "ryvUSDC-ETH-P-THETA": v2deployment.mainnet.RibbonYearnETHPutLiquidityGauge,
            "rAAVE-THETA": v2deployment.mainnet.RibbonAAVECoveredCallLiquidityGauge,
            "rstETH-THETA": v2deployment.mainnet.RibbonSTETHCoveredLiquidityGauge,
            "rETH-THETA": v2deployment.mainnet.RibbonETHCoveredCallLiquidityGauge,
            "rBTC-THETA": v2deployment.mainnet.RibbonWBTCCoveredCallLiquidityGauge,
            "rrETH-THETA": v2deployment.mainnet.RibbonRETHCoveredCallLiquidityGauge,
        },
    };
export var isPutVault = function (vault) {
    return PutThetaVault.includes(vault);
};
export var isEarnVault = function (vault) {
    return EarnVaultList.includes(vault) || AllEarnVaults.includes(vault);
};
export var VaultAddressMap = {
    "rUSDC-ETH-P-THETA": isDevelopment()
        ? {
            v1: v1deployment.kovan.RibbonETHPut,
            v2: v2deployment.kovan.RibbonThetaVaultETHPut,
            chainId: CHAINID.ETH_KOVAN,
        }
        : {
            v1: v1deployment.mainnet.RibbonETHPut,
            chainId: CHAINID.ETH_MAINNET,
        },
    "rETH-THETA": isDevelopment()
        ? {
            v1: v1deployment.kovan.RibbonETHCoveredCall,
            v2: v2deployment.kovan.RibbonThetaVaultETHCall,
            chainId: CHAINID.ETH_KOVAN,
        }
        : {
            v1: v1deployment.mainnet.RibbonETHCoveredCall,
            v2: v2deployment.mainnet.RibbonThetaVaultETHCall,
            chainId: CHAINID.ETH_MAINNET,
        },
    "rBTC-THETA": isDevelopment()
        ? {
            v1: v1deployment.kovan.RibbonWBTCCoveredCall,
            v2: v2deployment.kovan.RibbonThetaVaultWBTCCall,
            chainId: CHAINID.ETH_KOVAN,
        }
        : {
            v1: v1deployment.mainnet.RibbonWBTCCoveredCall,
            v2: v2deployment.mainnet.RibbonThetaVaultWBTCCall,
            chainId: CHAINID.ETH_MAINNET,
        },
    "ryvUSDC-ETH-P-THETA": isDevelopment()
        ? {
            v1: v1deployment.kovan.RibbonYearnETHPut,
            chainId: CHAINID.ETH_KOVAN,
        }
        : {
            v1: v1deployment.mainnet.RibbonYearnETHPut,
            v2: v2deployment.mainnet.RibbonThetaYearnVaultETHPut,
            chainId: CHAINID.ETH_MAINNET,
        },
    "rstETH-THETA": isDevelopment()
        ? {
            /**
             * We use ETH vault for Kovan preview
             */
            v2: v2deployment.kovan.RibbonThetaVaultETHCall,
            chainId: CHAINID.ETH_KOVAN,
        }
        : {
            v2: v2deployment.mainnet.RibbonThetaVaultSTETHCall,
            chainId: CHAINID.ETH_MAINNET,
        },
    "rrETH-THETA": isDevelopment()
        ? {
            v2: v2deployment.kovan.RibbonThetaVaultRETHCall,
            chainId: CHAINID.ETH_MAINNET,
        }
        : {
            v2: v2deployment.mainnet.RibbonThetaVaultRETHCall,
            chainId: CHAINID.ETH_MAINNET,
        },
    "rAAVE-THETA": isDevelopment()
        ? {
            /**
             * We use ETH vault for Kovan preview
             */
            v2: v2deployment.kovan.RibbonThetaVaultETHCall,
            chainId: CHAINID.ETH_KOVAN,
        }
        : {
            v2: v2deployment.mainnet.RibbonThetaVaultAAVECall,
            chainId: CHAINID.ETH_MAINNET,
        },
    "rUNI-THETA": isDevelopment()
        ? {
            /**
             * We use ETH vault for Kovan preview
             */
            v2: v2deployment.kovan.RibbonThetaVaultETHCall,
            chainId: CHAINID.ETH_KOVAN,
        }
        : {
            v2: v2deployment.mainnet.RibbonThetaVaultUNICall,
            chainId: CHAINID.ETH_MAINNET,
        },
    "rAVAX-THETA": isDevelopment()
        ? {
            v2: v2deployment.fuji.RibbonThetaVaultAVAXCall,
            chainId: CHAINID.AVAX_FUJI,
        }
        : {
            v2: v2deployment.avax.RibbonThetaVaultAVAXCall,
            chainId: CHAINID.AVAX_MAINNET,
        },
    "rsAVAX-THETA": isDevelopment()
        ? {
            v2: v2deployment.fuji.RibbonThetaVaultSAVAXCall,
            chainId: CHAINID.AVAX_FUJI,
        }
        : {
            v2: v2deployment.avax.RibbonThetaVaultSAVAXCall,
            chainId: CHAINID.AVAX_MAINNET,
        },
    "rUSDC-AVAX-P-THETA": isDevelopment()
        ? {
            v2: v2deployment.avax.RibbonThetaVaultAVAXPut,
            chainId: CHAINID.AVAX_FUJI,
        }
        : {
            v2: v2deployment.avax.RibbonThetaVaultAVAXPut,
            chainId: CHAINID.AVAX_MAINNET,
        },
    "rPERP-TSRY": isDevelopment()
        ? {
            v2: v2deployment.kovan.RibbonTreasuryVaultPERP,
            chainId: CHAINID.ETH_KOVAN,
        }
        : {
            v2: v2deployment.mainnet.RibbonTreasuryVaultPERP,
            chainId: CHAINID.ETH_MAINNET,
        },
    "rBAL-TSRY": isDevelopment()
        ? {
            v2: v2deployment.kovan.RibbonTreasuryVaultBAL,
            chainId: CHAINID.ETH_KOVAN,
        }
        : {
            v2: v2deployment.mainnet.RibbonTreasuryVaultBAL,
            chainId: CHAINID.ETH_MAINNET,
        },
    "rBADGER-TSRY": isDevelopment()
        ? {
            v2: v2deployment.kovan.RibbonTreasuryVaultBADGER,
            chainId: CHAINID.ETH_KOVAN,
        }
        : {
            v2: v2deployment.mainnet.RibbonTreasuryVaultBADGER,
            chainId: CHAINID.ETH_MAINNET,
        },
    "rSPELL-TSRY": isDevelopment()
        ? {
            v2: v2deployment.kovan.RibbonTreasuryVaultSPELL,
            chainId: CHAINID.ETH_KOVAN,
        }
        : {
            v2: v2deployment.mainnet.RibbonTreasuryVaultSPELL,
            chainId: CHAINID.ETH_MAINNET,
        },
    "rSAMB-TSRY": isDevelopment()
        ? {
            v2: v2deployment.kovan.RibbonTreasuryVaultSAMB,
            chainId: CHAINID.ETH_KOVAN,
        }
        : {
            v2: v2deployment.mainnet.RibbonTreasuryVaultSAMB,
            chainId: CHAINID.ETH_MAINNET,
        },
    "rVIP-wBTC": isDevelopment()
        ? {
            earn: v2deployment.kovan.RibbonVIPVaultWBTC,
            chainId: CHAINID.ETH_KOVAN,
        }
        : {
            earn: v2deployment.mainnet.RibbonVIPVaultWBTC,
            chainId: CHAINID.ETH_MAINNET,
        },
    "rVIP-USDC": isDevelopment()
        ? {
            earn: v2deployment.kovan.RibbonVIPVaultUSDC,
            chainId: CHAINID.ETH_KOVAN,
        }
        : {
            earn: v2deployment.mainnet.RibbonVIPVaultUSDC,
            chainId: CHAINID.ETH_MAINNET,
        },
    "rVIP-VOL": isDevelopment()
        ? {
            earn: v2deployment.kovan.RibbonVIPVaultVOL,
            chainId: CHAINID.ETH_KOVAN,
        }
        : {
            earn: v2deployment.mainnet.RibbonVIPVaultVOL,
            chainId: CHAINID.ETH_MAINNET,
        },
    "rVIP-VOL-TWO": isDevelopment()
        ? {
            earn: v2deployment.kovan.RibbonVIPVaultVOLTWO,
            chainId: CHAINID.ETH_KOVAN,
        }
        : {
            earn: v2deployment.mainnet.RibbonVIPVaultVOLTWO,
            chainId: CHAINID.ETH_MAINNET,
        },
    // FIXME: change with real addresses
    "rSOL-THETA": {
        v2: getSolanaAddresses().vaults["rSOL-THETA"],
        chainId: 99999999, // we stub this out with a fake chainid
    },
    "rAPE-THETA": {
        v2: v2deployment.mainnet.RibbonThetaVaultAPECall,
        chainId: CHAINID.ETH_MAINNET,
    },
    "rBNB-THETA": {
        v2: v2deployment.bsc.RibbonThetaVaultBNBCall,
        chainId: CHAINID.BINANCE_MAINNET,
    },
    rEARN: {
        earn: v2deployment.mainnet.RibbonEarnUSDC,
        chainId: CHAINID.ETH_MAINNET,
    },
    "rEARN-stETH": {
        earn: v2deployment.mainnet.RibbonEarnSTETH,
        chainId: CHAINID.ETH_MAINNET,
    },
};
/**
 * Used to check if vault of given version exists. Only used for v2 and above
 * @param vaultOption
 * @returns boolean
 */
export var hasVaultVersion = function (vaultOption, version) {
    return Boolean(VaultAddressMap[vaultOption][version]);
};
export var VaultNamesList = [
    "T-USDC-P-ETH",
    "T-ETH-C",
    "T-WBTC-C",
    "T-yvUSDC-P-ETH",
    "T-stETH-C",
    "T-rETH-C",
    "T-AAVE-C",
    "T-UNI-C",
    "T-BNB-C",
    "T-AVAX-C",
    "T-sAVAX-C",
    "T-USDC-P-AVAX",
    "T-PERP-C",
    "T-BAL-C",
    "T-BADGER-C",
    "T-SPELL-C",
    "T-SAMB-C",
    "R-VIP-WBTC",
    "R-VIP-USDC",
    "R-VIP-VOL",
    "R-VIP-VOL-TWO",
    "T-SOL-C",
    "T-APE-C",
    "R-EARN",
    "R-stETH-EARN",
];
export var VaultNameOptionMap = {
    "T-USDC-P-ETH": "rUSDC-ETH-P-THETA",
    "T-ETH-C": "rETH-THETA",
    "T-WBTC-C": "rBTC-THETA",
    "T-yvUSDC-P-ETH": "ryvUSDC-ETH-P-THETA",
    "T-stETH-C": "rstETH-THETA",
    "T-rETH-C": "rrETH-THETA",
    "T-AAVE-C": "rAAVE-THETA",
    "T-UNI-C": "rUNI-THETA",
    "T-BNB-C": "rBNB-THETA",
    "T-AVAX-C": "rAVAX-THETA",
    "T-sAVAX-C": "rsAVAX-THETA",
    "T-USDC-P-AVAX": "rUSDC-AVAX-P-THETA",
    "T-PERP-C": "rPERP-TSRY",
    "T-BAL-C": "rBAL-TSRY",
    "T-BADGER-C": "rBADGER-TSRY",
    "T-SPELL-C": "rSPELL-TSRY",
    "T-SAMB-C": "rSAMB-TSRY",
    "R-VIP-WBTC": "rVIP-wBTC",
    "R-VIP-USDC": "rVIP-USDC",
    "R-VIP-VOL": "rVIP-VOL",
    "R-VIP-VOL-TWO": "rVIP-VOL-TWO",
    "T-SOL-C": "rSOL-THETA",
    "T-APE-C": "rAPE-THETA",
    "R-EARN": "rEARN",
    "R-stETH-EARN": "rEARN-stETH",
};
// Reverse lookup for VaultNameOptionMap
export var vaultOptionToName = function (option) {
    var match = Object.entries(VaultNameOptionMap).find(function (_a) {
        var name = _a[0], optionName = _a[1];
        return optionName === option;
    });
    if (match) {
        return match[0];
    }
    return undefined;
};
export var EVM_BLOCKCHAIN_EXPLORER_NAME = (_e = {},
    _e[CHAINID.ETH_MAINNET] = "Etherscan",
    _e[CHAINID.ETH_KOVAN] = "Etherscan",
    _e[CHAINID.AVAX_MAINNET] = "SnowTrace",
    _e[CHAINID.AVAX_FUJI] = "SnowTrace",
    _e[CHAINID.BINANCE_MAINNET] = "BscScan",
    _e);
export var EVM_BLOCKCHAIN_EXPLORER_URI = (_f = {},
    _f[CHAINID.ETH_MAINNET] = "https://etherscan.io",
    _f[CHAINID.ETH_KOVAN] = "https://kovan.etherscan.io",
    _f[CHAINID.AVAX_MAINNET] = "https://snowtrace.io",
    _f[CHAINID.AVAX_FUJI] = "https://testnet.snowtrace.io",
    _f[CHAINID.BINANCE_MAINNET] = "https://bscscan.com",
    _f);
export var AVAX_BRIDGE_URI = "https://bridge.avax.network";
export var getExplorerName = function (chain) {
    if (chain === Chains.Solana) {
        return "Solscan";
    }
    return EVM_BLOCKCHAIN_EXPLORER_NAME[CHAINS_TO_ID[chain]];
};
// Left here for compatibility purposes
export var getEtherscanURI = function (chainId) {
    return EVM_BLOCKCHAIN_EXPLORER_URI[chainId];
};
export var getExplorerURI = function (chain) {
    if (chain === Chains.Solana) {
        return "https://solscan.io";
    }
    return EVM_BLOCKCHAIN_EXPLORER_URI[CHAINS_TO_ID[chain]];
};
export var getSubgraphURIForVersion = function (version, chain) {
    switch (version) {
        case "v1":
            return getSubgraphqlURI();
        case "v2":
            switch (chain) {
                case Chains.Ethereum:
                case Chains.Avalanche:
                case Chains.Binance:
                    return SUBGRAPH_URI[CHAINS_TO_ID[chain]];
                case Chains.Solana:
                    return SOLANA_SUBGRAPH;
                default:
                    throw new Error("No found subgraph");
            }
        case "earn":
            return getSubgraphqlRearnURI();
    }
};
export var getAssets = function (vault) {
    switch (vault) {
        case "rUSDC-ETH-P-THETA":
        case "ryvUSDC-ETH-P-THETA":
            return "USDC";
        case "rUSDC-AVAX-P-THETA":
            return "USDC.e";
        case "rETH-THETA":
            return "WETH";
        case "rstETH-THETA":
        case "rEARN-stETH":
            return "stETH";
        case "rrETH-THETA":
            return "rETH";
        case "rBTC-THETA":
            return "WBTC";
        case "rAAVE-THETA":
            return "AAVE";
        case "rUNI-THETA":
            return "UNI";
        case "rBNB-THETA":
            return "WBNB";
        case "rAVAX-THETA":
            return "WAVAX";
        case "rsAVAX-THETA":
            return "sAVAX";
        case "rPERP-TSRY":
            return "PERP";
        case "rBAL-TSRY":
            return "BAL";
        case "rBADGER-TSRY":
            return "BADGER";
        case "rSPELL-TSRY":
            return "SPELL";
        case "rSAMB-TSRY":
            return "SAMB";
        case "rVIP-wBTC":
            return "WBTC";
        case "rVIP-USDC":
            return "USDC";
        case "rVIP-VOL":
            return "USDC";
        case "rVIP-VOL-TWO":
            return "USDC";
        case "rSOL-THETA":
            return "SOL";
        case "rAPE-THETA":
            return "APE";
        case "rEARN":
            return "USDC";
        default:
            return "USDC";
    }
};
export var getOptionAssets = function (vault) {
    switch (vault) {
        case "rBTC-THETA":
            return "WBTC";
        case "rETH-THETA":
        case "rUSDC-ETH-P-THETA":
        case "ryvUSDC-ETH-P-THETA":
        case "rrETH-THETA":
        case "rEARN-stETH":
        case "rstETH-THETA":
            return "WETH";
        case "rAAVE-THETA":
            return "AAVE";
        case "rUNI-THETA":
            return "UNI";
        case "rBNB-THETA":
            return "WBNB";
        case "rAVAX-THETA":
        case "rUSDC-AVAX-P-THETA":
            return "WAVAX";
        case "rsAVAX-THETA":
            return "sAVAX";
        case "rPERP-TSRY":
            return "PERP";
        case "rBAL-TSRY":
            return "BAL";
        case "rBADGER-TSRY":
            return "BADGER";
        case "rSPELL-TSRY":
            return "SPELL";
        case "rSAMB-TSRY":
            return "SAMB";
        case "rVIP-wBTC":
            return "WBTC";
        case "rVIP-USDC":
            return "USDC";
        case "rVIP-VOL":
            return "USDC";
        case "rVIP-VOL-TWO":
            return "USDC";
        case "rSOL-THETA":
            return "SOL";
        case "rAPE-THETA":
            return "APE";
        case "rEARN":
            return "USDC";
        default:
            return "USDC";
    }
};
export var getDisplayAssets = function (vault) {
    switch (vault) {
        case "rUSDC-ETH-P-THETA":
            return "USDC";
        case "rUSDC-AVAX-P-THETA":
            return "USDC.e";
        case "rETH-THETA":
            return "WETH";
        case "rBTC-THETA":
            return "WBTC";
        case "ryvUSDC-ETH-P-THETA":
            return "USDC";
        case "rstETH-THETA":
        case "rEARN-stETH":
            return "stETH";
        case "rrETH-THETA":
            return "rETH";
        case "rAAVE-THETA":
            return "AAVE";
        case "rUNI-THETA":
            return "UNI";
        case "rBNB-THETA":
            return "WBNB";
        case "rAVAX-THETA":
            return "WAVAX";
        case "rsAVAX-THETA":
            return "sAVAX";
        case "rPERP-TSRY":
            return "PERP";
        case "rBAL-TSRY":
            return "BAL";
        case "rBADGER-TSRY":
            return "BADGER";
        case "rSPELL-TSRY":
            return "SPELL";
        case "rSAMB-TSRY":
            return "SAMB";
        case "rVIP-wBTC":
            return "WBTC";
        case "rVIP-USDC":
            return "USDC";
        case "rVIP-VOL":
            return "USDC";
        case "rVIP-VOL-TWO":
            return "USDC";
        case "rSOL-THETA":
            return "SOL";
        case "rAPE-THETA":
            return "APE";
        case "rEARN":
            return "USDC";
        default:
            return "USDC";
    }
};
export var VaultAllowedDepositAssets = {
    "rAAVE-THETA": ["AAVE"],
    "rUNI-THETA": ["UNI"],
    "rBTC-THETA": ["WBTC"],
    "rETH-THETA": ["WETH"],
    "rBNB-THETA": ["WBNB"],
    "rAVAX-THETA": ["WAVAX"],
    "rsAVAX-THETA": ["WAVAX", "sAVAX"],
    "rUSDC-ETH-P-THETA": ["USDC"],
    "rUSDC-AVAX-P-THETA": ["USDC.e"],
    "rstETH-THETA": ["WETH", "stETH"],
    "rrETH-THETA": ["WETH", "rETH"],
    "ryvUSDC-ETH-P-THETA": ["USDC"],
    "rPERP-TSRY": ["PERP"],
    "rBAL-TSRY": ["BAL"],
    "rBADGER-TSRY": ["BADGER"],
    "rSPELL-TSRY": ["SPELL"],
    "rSAMB-TSRY": ["SAMB"],
    "rVIP-wBTC": ["WBTC"],
    "rVIP-USDC": ["USDC"],
    "rVIP-VOL": ["USDC"],
    "rVIP-VOL-TWO": ["USDC"],
    "rSOL-THETA": ["SOL"],
    "rAPE-THETA": ["APE"],
    rEARN: ["USDC"],
    "rEARN-stETH": ["WETH", "stETH"],
};
export var getEarnSkipStorage = function (vault) {
    switch (vault) {
        case "rEARN":
            return "skipEARNExplanation";
        case "rEARN-stETH":
            return "skipEARNSTETHExplanation";
        default:
            return "";
    }
};
export var VaultMaxDeposit = {
    "rUSDC-ETH-P-THETA": BigNumber.from(100000000).mul(BigNumber.from(10).pow(getAssetDecimals(getAssets("rUSDC-ETH-P-THETA")))),
    "rETH-THETA": BigNumber.from(50000).mul(BigNumber.from(10).pow(getAssetDecimals(getAssets("rETH-THETA")))),
    "rBTC-THETA": BigNumber.from(2000).mul(BigNumber.from(10).pow(getAssetDecimals(getAssets("rBTC-THETA")))),
    "ryvUSDC-ETH-P-THETA": BigNumber.from(100000000).mul(BigNumber.from(10).pow(getAssetDecimals(getAssets("ryvUSDC-ETH-P-THETA")))),
    "rUSDC-AVAX-P-THETA": BigNumber.from(100000000).mul(BigNumber.from(10).pow(getAssetDecimals(getAssets("rUSDC-AVAX-P-THETA")))),
    // TODO: Confirm max deposit for stETH vault
    "rstETH-THETA": BigNumber.from(50000).mul(BigNumber.from(10).pow(getAssetDecimals(getAssets("rstETH-THETA")))),
    "rrETH-THETA": BigNumber.from(50000).mul(BigNumber.from(10).pow(getAssetDecimals(getAssets("rrETH-THETA")))),
    "rAAVE-THETA": BigNumber.from(20000).mul(BigNumber.from(10).pow(getAssetDecimals(getAssets("rAAVE-THETA")))),
    "rUNI-THETA": BigNumber.from(20000).mul(BigNumber.from(10).pow(getAssetDecimals(getAssets("rUNI-THETA")))),
    "rBNB-THETA": BigNumber.from(100000000).mul(BigNumber.from(10).pow(getAssetDecimals(getAssets("rBNB-THETA")))),
    "rAVAX-THETA": BigNumber.from(100000000).mul(BigNumber.from(10).pow(getAssetDecimals(getAssets("rAVAX-THETA")))),
    "rsAVAX-THETA": BigNumber.from(100000000).mul(BigNumber.from(10).pow(getAssetDecimals(getAssets("rsAVAX-THETA")))),
    "rPERP-TSRY": BigNumber.from(100000000).mul(BigNumber.from(10).pow(getAssetDecimals(getAssets("rPERP-TSRY")))),
    "rBAL-TSRY": BigNumber.from(100000000).mul(BigNumber.from(10).pow(getAssetDecimals(getAssets("rBAL-TSRY")))),
    "rBADGER-TSRY": BigNumber.from(100000000).mul(BigNumber.from(10).pow(getAssetDecimals(getAssets("rBADGER-TSRY")))),
    "rSPELL-TSRY": BigNumber.from(1000000000).mul(BigNumber.from(10).pow(getAssetDecimals(getAssets("rSPELL-TSRY")))),
    "rSAMB-TSRY": BigNumber.from(1000000000).mul(BigNumber.from(10).pow(getAssetDecimals(getAssets("rSAMB-TSRY")))),
    "rVIP-wBTC": BigNumber.from(50).mul(BigNumber.from(10).pow(getAssetDecimals(getAssets("rVIP-wBTC")))),
    "rVIP-USDC": BigNumber.from(100000000).mul(BigNumber.from(10).pow(getAssetDecimals(getAssets("rVIP-USDC")))),
    "rVIP-VOL": BigNumber.from(100000000).mul(BigNumber.from(10).pow(getAssetDecimals(getAssets("rVIP-VOL")))),
    "rVIP-VOL-TWO": BigNumber.from(100000000).mul(BigNumber.from(10).pow(getAssetDecimals(getAssets("rVIP-VOL-TWO")))),
    // FIXME: change with real numbers
    "rSOL-THETA": BigNumber.from(100000000).mul(BigNumber.from(10).pow(getAssetDecimals(getAssets("rSOL-THETA")))),
    "rAPE-THETA": BigNumber.from(100000000).mul(BigNumber.from(10).pow(getAssetDecimals(getAssets("rAPE-THETA")))),
    rEARN: BigNumber.from(100000000).mul(BigNumber.from(10).pow(getAssetDecimals(getAssets("rEARN")))),
    "rEARN-stETH": BigNumber.from(50000).mul(BigNumber.from(10).pow(getAssetDecimals(getAssets("rEARN-stETH")))),
};
export var VaultFees = {
    "rUSDC-ETH-P-THETA": {
        v1: {
            withdrawalFee: "1.0",
        },
    },
    "rETH-THETA": {
        v1: {
            withdrawalFee: "0.5",
        },
        v2: {
            managementFee: "2",
            performanceFee: "10",
        },
    },
    "rBTC-THETA": {
        v1: {
            withdrawalFee: "0.5",
        },
        v2: {
            managementFee: "2",
            performanceFee: "10",
        },
    },
    "ryvUSDC-ETH-P-THETA": {
        v1: {
            withdrawalFee: "1.0",
        },
        v2: {
            managementFee: "2",
            performanceFee: "10",
        },
    },
    "rstETH-THETA": {
        v2: {
            managementFee: "2",
            performanceFee: "10",
        },
    },
    "rrETH-THETA": {
        v2: {
            managementFee: "2",
            performanceFee: "10",
        },
    },
    "rAAVE-THETA": {
        v2: {
            managementFee: "2",
            performanceFee: "10",
        },
    },
    "rUNI-THETA": {
        v2: {
            managementFee: "2",
            performanceFee: "10",
        },
    },
    "rAVAX-THETA": {
        v2: {
            managementFee: "2",
            performanceFee: "10",
        },
    },
    "rsAVAX-THETA": {
        v2: {
            managementFee: "2",
            performanceFee: "10",
        },
    },
    "rBNB-THETA": {
        v2: {
            managementFee: "2",
            performanceFee: "10",
        },
    },
    "rUSDC-AVAX-P-THETA": {
        v2: {
            managementFee: "2",
            performanceFee: "10",
        },
    },
    "rPERP-TSRY": {
        v2: {
            managementFee: "2",
            performanceFee: "10",
        },
    },
    "rBAL-TSRY": {
        v2: {
            managementFee: "2",
            performanceFee: "10",
        },
    },
    "rBADGER-TSRY": {
        v2: {
            managementFee: "2",
            performanceFee: "10",
        },
    },
    "rSPELL-TSRY": {
        v2: {
            managementFee: "2",
            performanceFee: "10",
        },
    },
    "rSAMB-TSRY": {
        v2: {
            managementFee: "2",
            performanceFee: "10",
        },
    },
    "rVIP-wBTC": {
        earn: {
            managementFee: "0",
            performanceFee: "0",
        },
    },
    "rVIP-VOL": {
        earn: {
            managementFee: "0",
            performanceFee: "0",
        },
    },
    "rVIP-VOL-TWO": {
        earn: {
            managementFee: "0",
            performanceFee: "0",
        },
    },
    "rVIP-USDC": {
        earn: {
            managementFee: "0",
            performanceFee: "0",
        },
    },
    // FIXME: Change with real values
    "rSOL-THETA": {
        v2: {
            managementFee: "2",
            performanceFee: "10",
        },
    },
    "rAPE-THETA": {
        v2: {
            managementFee: "2",
            performanceFee: "10",
        },
    },
    rEARN: {
        earn: {
            managementFee: "0",
            performanceFee: "15",
        },
    },
    "rEARN-stETH": {
        earn: {
            managementFee: "0",
            performanceFee: "10",
        },
    },
};
export var RibbonVaultMigrationMap = {
    "rBTC-THETA": {
        v2: ["rBTC-THETA"],
    },
    // TODO: Once we enable migrations into stETH vault
    // We can uncomment this
    // "rstETH-THETA": {
    //   v2: ["rETH-THETA"],
    // },
    "rETH-THETA": {
        v2: ["rETH-THETA"],
    },
    "ryvUSDC-ETH-P-THETA": {
        v2: ["ryvUSDC-ETH-P-THETA", "rUSDC-ETH-P-THETA"],
    },
};
export var v1ToV2MigrationMap = {
    "rBTC-THETA": "rBTC-THETA",
    "rETH-THETA": "rETH-THETA",
    // TODO: Uncomment this
    // "rETH-THETA": "rstETH-THETA",
    "rUSDC-ETH-P-THETA": "ryvUSDC-ETH-P-THETA",
    "ryvUSDC-ETH-P-THETA": "ryvUSDC-ETH-P-THETA",
};
export var RibbonTokenAddress = isDevelopment()
    ? v1deployment.kovan.RibbonToken
    : v1deployment.mainnet.RibbonToken;
export var getERC20TokenAddress = function (token, chainId) {
    var network = NETWORKS[chainId];
    return isDevelopment()
        ? addresses[network].assets[token]
        : addresses[network].assets[token];
};
export var LidoOracleAddress = isDevelopment()
    ? ""
    : addresses.mainnet.lidoOracle;
export var STETHDepositHelperAddress = isDevelopment()
    ? ""
    : addresses.mainnet.stETHDepositHelper;
export var EarnSTETHDepositHelperAddress = isDevelopment()
    ? ""
    : addresses.mainnet.earnStETHDepositHelper;
export var CurveLidoPoolAddress = isDevelopment()
    ? ""
    : addresses.mainnet.lidoCurvePool;
export var RibbonTreasuryAddress = (_g = {},
    _g[CHAINID.ETH_KOVAN] = "0xD380980791079Bd50736Ffe577b8D57A3C196ccd",
    _g[CHAINID.ETH_MAINNET] = "0xDAEada3d210D2f45874724BeEa03C7d4BBD41674",
    _g);
export var CurveFeeDistributionAddress = isDevelopment()
    ? governanceDeployment.kovan.CurveFeeDistribution
    : governanceDeployment.mainnet.CurveFeeDistribution;
export var PenaltyRewardsAddress = isDevelopment()
    ? governanceDeployment.kovan.RBNPenaltyRewards
    : governanceDeployment.mainnet.RBNPenaltyRewards;
export var PenaltyRewardsPostTimestampAddress = governanceDeployment.mainnet.RBNPenaltyRewardsPostTimestamp;
export var FeeDistributorAddress = isDevelopment()
    ? governanceDeployment.kovan.RBNFeeDistributor
    : governanceDeployment.mainnet.RBNFeeDistributor;
export var VotingEscrowAddress = isDevelopment()
    ? governanceDeployment.kovan.RBNVotingEscrow
    : governanceDeployment.mainnet.RBNVotingEscrow;
export var VotingEscrowDelegationProxyAddress = isDevelopment()
    ? governanceDeployment.kovan.RBNVotingEscrowDelegationProxy
    : governanceDeployment.mainnet.RBNVotingEscrowDelegationProxy;
export var LiquidityTokenMinterAddress = isDevelopment()
    ? governanceDeployment.kovan.RBNVotingTokenMinter
    : governanceDeployment.mainnet.RBNVotingTokenMinter;
export var LiquidityGaugeControllerAddress = isDevelopment()
    ? governanceDeployment.kovan.RBNVotingGaugeController
    : governanceDeployment.mainnet.RBNVotingGaugeController;
export var RibbonVaultPauserAddress = (_h = {},
    _h[CHAINID.ETH_KOVAN] = v2deployment.kovan.RibbonVaultPauser,
    _h[CHAINID.ETH_MAINNET] = v2deployment.mainnet.RibbonVaultPauser,
    _h[CHAINID.AVAX_MAINNET] = v2deployment.avax.RibbonVaultPauser,
    _h);
export var READABLE_CHAIN_NAMES = (_j = {},
    _j[Chains.Ethereum] = "Ethereum",
    _j[Chains.Avalanche] = "Avalanche",
    _j[Chains.Binance] = "Binance",
    _j[Chains.Solana] = "Solana",
    _j[Chains.NotSelected] = "No Chain Selected",
    _j);
export var ENABLED_CHAINS = [
    Chains.Ethereum,
    Chains.Avalanche,
    Chains.Binance,
    Chains.Solana,
];
export var CHAINS_TO_NATIVE_TOKENS = (_k = {},
    _k[Chains.Ethereum] = "WETH",
    _k[Chains.Avalanche] = "WAVAX",
    _k[Chains.Binance] = "WBNB",
    _k[Chains.Solana] = "SOL",
    _k[Chains.NotSelected] = "WETH",
    _k);
export var CHAINS_TO_ID = (_l = {},
    _l[Chains.Ethereum] = isDevelopment() ? CHAINID.ETH_KOVAN : CHAINID.ETH_MAINNET,
    _l[Chains.Avalanche] = isDevelopment()
        ? CHAINID.AVAX_FUJI
        : CHAINID.AVAX_MAINNET,
    _l[Chains.Binance] = CHAINID.BINANCE_MAINNET,
    _l);
export var ID_TO_CHAINS = (_m = {},
    _m[CHAINID.ETH_KOVAN] = Chains.Ethereum,
    _m[CHAINID.ETH_MAINNET] = Chains.Ethereum,
    _m[CHAINID.AVAX_FUJI] = Chains.Avalanche,
    _m[CHAINID.AVAX_MAINNET] = Chains.Avalanche,
    _m[CHAINID.BINANCE_MAINNET] = Chains.Binance,
    _m);
export var getSolanaVaultInstance = function (vaultOption) {
    var vaults = getSolanaAddresses().vaults;
    if (vaults[vaultOption])
        return new PublicKey(vaults[vaultOption]);
    throw new Error("No solana vault ".concat(vaultOption));
};
var WEBAPP_SUBGRAPHS = [
    ["v1", Chains.Ethereum],
    ["v2", Chains.Ethereum],
    ["earn", Chains.Ethereum],
    ["v2", Chains.Avalanche],
    ["v2", Chains.Binance],
    ["v2", Chains.Solana],
];
var TREASURY_SUBGRAPHS = [
    ["v2", Chains.Ethereum],
    ["earn", Chains.Ethereum],
];
var VIP_SUBGRAPHS = [["earn", Chains.Ethereum]];
export var SUBGRAPHS_TO_QUERY = isTreasury()
    ? TREASURY_SUBGRAPHS
    : isVIP()
        ? VIP_SUBGRAPHS
        : WEBAPP_SUBGRAPHS;
export var COINGECKO_AWS_BASE_URL = process.env.REACT_APP_COINGECKO_AWS_BASE_URL;
export var COINGECKO_CURRENCIES = {
    WETH: "ethereum",
    WBTC: "wrapped-bitcoin",
    USDC: "usd-coin",
    "USDC.e": "usd-coin",
    yvUSDC: undefined,
    stETH: "staked-ether",
    rETH: "rocket-pool-eth",
    wstETH: "wrapped-steth",
    LDO: "lido-dao",
    AAVE: "aave",
    UNI: "uniswap",
    WBNB: "binancecoin",
    WAVAX: "avalanche-2",
    sAVAX: "benqi-liquid-staked-avax",
    PERP: "perpetual-protocol",
    BAL: "balancer",
    BADGER: "badger-dao",
    SPELL: "spell-token",
    SAMB: "amber",
    RBN: "ribbon-finance",
    veRBN: undefined,
    SOL: "solana",
    APE: "apecoin",
};
var DISABLED_VAULTS = [
    "rAPE-THETA",
    "rUSDC-AVAX-P-THETA",
    "rUNI-THETA",
    "rSOL-THETA",
    "rBNB-THETA",
];
export var isDisabledVault = function (vaultOption) {
    return DISABLED_VAULTS.includes(vaultOption);
};
export var tokenApprovalMaxAmount = "115792089237316195423570985008687907853269984665640564039457584007913129639935";
export var URLS = {
    surge: "https://surge.bot",
    surgeTerms: "https://surge.bot/terms",
    surgePolicy: "https://surge.bot/policy",
    surgeFaq: "https://surge.bot/faq",
    ribbonApp: "https://app.surge.bot",
    research: "https://docs.surge.bot",
    // lend
    lend: "https://lend.surge.bot",
    lendApp: "https://lend.surge.bot/app",
    // vip
    vip: "https://vip.surge.bot",
    // governance
    governance: "https://vote.surge.bot",
    snapshot: "",
    // auction
    auction: "",
    // treasury
    treasury: "https://treasury.surge.bot",
    // socials
    twitter: "",
    github: "",
    discord: "",
    medium: "",
    // docs
    docs: "https://docs.surge.bot",
    docsFaq: "https://docs.surge.bot",
    // others
    tokenterminal: "",
    defillama: "",
    arkham: "",
    coingecko: "",
    hiddenhand: "",
};
//# sourceMappingURL=constants.js.map